/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { CONFIGURATION } from 'apps/console-core/src/Constants/DxpCapabilities/DxpCapabilityItems.constants';

/**
 * Get a generated event service path to the chosen screen.
 * @param {string} screenPath The relative path of the screen within the event service (must start with '/').
 * @export
 * @returns {string} A generated event service path for the chosen screen.
 */
export const getEventServicePath = (screenPath: string): string => {
  return `${CONFIGURATION.path}/event-service${screenPath}`;
};
